import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'
import { providesList, invialidateList, invialidateListById } from 'Utils/rtk-query'

export const usersApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'usersApi',
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    listUsers: builder.query({
      query: (params) => {
        return {
          method: 'GET',
          url: '/v1/users/',
          params
        }
      },
      providesTags: (response) => providesList(response?.results, 'Users')
    }),
    updateUser: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data
        return {
          method: 'PATCH',
          url: `/v1/users/${id}`,
          body: payload
        }
      },
      invalidatesTags: (_result, _error, data) => invialidateListById('Users', data.id)
    }),
    deleteUser: builder.mutation({
      query: (id) => {
        return {
          method: 'DELETE',
          url: `/v1/users/${id}`
        }
      },
      invalidatesTags: (_result, _error, id) => invialidateListById('Users', id)
    }),
    deactivateUser: builder.mutation({
      query: (id) => {
        return {
          method: 'DELETE',
          url: `/v1/users/${id}/deactivate`
        }
      },
      invalidatesTags: (_result, _error, id) => invialidateListById('Users', id)
    }),
    activateUser: builder.mutation({
      query: (id) => {
        return {
          method: 'POST',
          url: `/v1/users/${id}/activate`
        }
      },
      invalidatesTags: (_result, _error, id) => invialidateListById('Users', id)
    }),
    inviteUser: builder.mutation({
      query: (payload) => {
        return {
          method: 'POST',
          url: '/v1/users/invite',
          body: payload
        }
      },
      invalidatesTags: invialidateList('Users')
    })
  })
})

export const {
  useListUsersQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useDeactivateUserMutation,
  useActivateUserMutation,
  useInviteUserMutation
} = usersApi

export default usersApi
